import { render, staticRenderFns } from "./UnderDepartmentList.vue?vue&type=template&id=c4707fee&scoped=true"
import script from "./UnderDepartmentList.vue?vue&type=script&lang=js"
export * from "./UnderDepartmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4707fee",
  null
  
)

export default component.exports